module.exports = __webpack_public_path__ + "media/country_flags/gr-d5c3855b.png";